import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RowWithThreeColumnsComponent } from './row-with-three-columns/row-with-three-columns.component';
import { RowWithTwoColumnsComponent } from './row-with-two-columns/row-with-two-columns.component';
import { SpacerComponent } from './spacer/spacer.component';
import { DialogComponent } from './dialog/dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { ErrorMessageWrapperComponent } from './error-message-wrapper/error-message-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';
import { SuccessCheckAnimationIconComponent } from './success-check-animation-icon/success-check-animation-icon.component';
import { SimpleStepProcessComponent } from './simple-step-process/simple-step-process.component';
import { BaseCardComponent } from './base-card/base-card.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { SuccessCheckAnimationDialogComponent } from './success-check-animation-dialog/success-check-animation-dialog.component';
import { PasswordValidationMessageComponent } from './password-validation-message/password-validation-message.component';
import { SmallAsideLayoutComponent } from './small-aside-layout/small-aside-layout.component';
import { DividerComponent } from './divider/divider.component';
import { CircleAnimationButtonComponent } from './circle-animation-button/circle-animation-button.component';
import { AnimatedDiscountIconComponent } from './animated-discount-icon/animated-discount-icon.component';
import { CustomerTypeBadgeComponent } from './customer-type-badge/customer-type-badge.component';
import { PipesModule } from '../../pipes';
import { SlideToggleContainerComponent } from './slide-toggle-container/slide-toggle-container.component';
import { BackArrowButtonComponent } from './back-arrow-button/back-arrow-button.component';
import { TextWithAvatarComponent } from './text-with-avatar/text-with-avatar.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { PaypalButtonComponent } from './paypal-button/paypal-button.component';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    PipesModule,
    TranslateModule.forChild(),
    InfiniteScrollDirective,
    // material design
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressBarModule,
    MatRippleModule,
  ],
  declarations: [
    AnimatedDiscountIconComponent,
    BackArrowButtonComponent,
    BaseCardComponent,
    CircleAnimationButtonComponent,
    CustomerTypeBadgeComponent,
    DialogComponent,
    DividerComponent,
    ErrorMessageWrapperComponent,
    InfoBoxComponent,
    PasswordValidationMessageComponent,
    PaypalButtonComponent,
    RowWithThreeColumnsComponent,
    RowWithTwoColumnsComponent,
    SimpleStepProcessComponent,
    SlideToggleContainerComponent,
    SmallAsideLayoutComponent,
    SpacerComponent,
    SuccessCheckAnimationDialogComponent,
    SuccessCheckAnimationIconComponent,
    TextWithAvatarComponent,
  ],
  exports: [
    AnimatedDiscountIconComponent,
    BackArrowButtonComponent,
    BaseCardComponent,
    CircleAnimationButtonComponent,
    CustomerTypeBadgeComponent,
    DialogComponent,
    DividerComponent,
    ErrorMessageWrapperComponent,
    InfoBoxComponent,
    PaypalButtonComponent,
    RowWithThreeColumnsComponent,
    RowWithTwoColumnsComponent,
    SimpleStepProcessComponent,
    SlideToggleContainerComponent,
    SmallAsideLayoutComponent,
    SpacerComponent,
    SuccessCheckAnimationDialogComponent,
    SuccessCheckAnimationIconComponent,
    TextWithAvatarComponent,
  ],
})
export class LibCoreLayoutModule {}
